import React, { CSSProperties } from 'react';
import { Box, Typography, Grid, Card, CardContent } from '@mui/material';
import useDownloadData from './downloads/downloadData';
import useLaborDownloadData from './downloads/laborDownloadData';

export const DownloadCard = ({
  title,
  description,
  children,
}: {
  title: string;
  description: { [key: string]: string | undefined };
  children: React.ReactNode;
}) => {
  const cardStyle: CSSProperties = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 2,
    border: '1px solid #E0E0E0',
  };

  const hasDescription = Object.keys(description).some((key) => description[key] !== undefined);

  return (
    <Grid
      item
      xs={12}
      sm={6}
    >
      <Card sx={cardStyle}>
        <CardContent >
          <Typography
            variant="h5"
            sx={{ mb: 1 }}
          >
            {title}
          </Typography>
          {hasDescription && (
            <Box
              mt={2}
              sx={{ flex: 1 }}
            >
              {Object.keys(description)
                .filter((key) => description[key] !== undefined)
                .map((key: string, index: number) => {
                  return (
                    <Typography
                      variant="body2"
                      key={index}
                      mt={index === 0 ? 0 : 1}
                    >
                      <span style={{ fontWeight: 'bold' }}>{key}:</span> {description[key]}
                    </Typography>
                  );
                })}
            </Box>
          )}
          <Box sx={{ mt: hasDescription ? 'auto' : 0.5 }}>{children}</Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

const SLMReports = () => {
  const { downloadData } = useDownloadData();
  //  RA-2027: second, independently flagged section. PBJ is a quarterly CMS staffing submission,
  //  not a month-end billing artifact, so it does not belong in the group above.
  const { laborDownloadData } = useLaborDownloadData();
  return (
    <Box sx={{ padding: 3 }}>
      <Typography
        sx={{ marginBottom: 3 }}
        fontSize={30}
        color={'#111927'}
        fontWeight={600}
      >
        Billing & Month-End Downloads
      </Typography>

      <Grid
        container
        spacing={3}
      >
        {downloadData.map((item, index) => {
          return (
            Boolean(Object.keys(item).length) && (
              <DownloadCard
                key={index}
                title={item.title || ''}
                description={item.description || {}}
              >
                {item.children}
              </DownloadCard>
            )
          );
        })}
      </Grid>

      {/*
        The heading is inside the guard on purpose. Rendering it unconditionally would leave every
        customer without the treatment looking at a bare "Labor" heading over nothing.
      */}
      {laborDownloadData.length > 0 && (
        <>
          <Typography
            sx={{ marginBottom: 3, marginTop: 5 }}
            fontSize={30}
            color={'#111927'}
            fontWeight={600}
          >
            Labor
          </Typography>

          <Grid
            container
            spacing={3}
          >
            {laborDownloadData.map((item, index) => {
              return (
                <DownloadCard
                  key={index}
                  title={item.title || ''}
                  description={item.description || {}}
                >
                  {item.children}
                </DownloadCard>
              );
            })}
          </Grid>
        </>
      )}
    </Box>
  );
};

export default SLMReports;
